export default __webpack_public_path__ + "static/media/abha_info.fe6dba01.mp4";